export const GHOST_ACCOUNT_QUERY_PARAM = 'ghostAccount';
